<template>
    <b-table table-class="bg-white" responsive bordered :items="resume"></b-table>
</template>

<script>
export default {
    props: {
        resume: {
            type: Array,
            required: true,
            default: () => []
        }
    }
}
</script>

<style scoped>

</style>
